export default {
  methods: {
    initials(fullName) {
      if (fullName) {
        var initials = decodeURI(fullName).match(/\b\w/g) || [];
        initials = (
          (initials.shift() || "") + (initials.pop() || "")
        ).toUpperCase();
        return initials;
      }
    },
  },
};
